module.exports = __webpack_public_path__ + "img/prize.641a035e.png";